import { Alerts } from 'components/alerts/Alerts';
import { MainLayout } from 'components/layout/MainLayout';
import { Locations } from 'components/locations/Locations';
import React from 'react';
import { BrowserRouter, generatePath, Navigate, Route, Routes } from 'react-router-v7';
import { UserRole } from 'shared';
import { Login } from '../components/login/Login';
import { routePath } from './routes';
import ProtectedRoute from './routes/ProtectedRoute';
import PublicRoute from './routes/PublicRoute';

import { observer } from 'mobx-react-lite';
import { userStore } from 'stores/userStore/userStore';

const AppRouter: React.FC = observer(() => {
	const getHomeRedirect = () => {
		const user = userStore.userContext;
		if (user.userRole === UserRole.ChainAdmin) {
			return <Navigate to={routePath.locations} replace />;
		}
		if (user.userRole === UserRole.LocationAdmin) {
			return <Navigate to={generatePath(routePath.alerts, { locationId: user.userWorkplaceId })} replace />;
		}
		return <Navigate to={routePath.login} replace />;
	};

	return (
		<BrowserRouter>
			<Routes>
				<Route element={<PublicRoute />}>
					<Route path={routePath.login} element={<Login />} />
				</Route>
				<Route element={<ProtectedRoute allowedRoles={[UserRole.ChainAdmin]} />}>
					<Route path={routePath.locations} element={<Locations />} />
				</Route>
				<Route element={<ProtectedRoute allowedRoles={[UserRole.LocationAdmin, UserRole.ChainAdmin]} />}>
					<Route element={<MainLayout />}>
						<Route path={routePath.alerts} element={<Alerts />} />
					</Route>
				</Route>
				<Route path={routePath.home} element={getHomeRedirect()} />
			</Routes>
		</BrowserRouter>
	);
});

export default AppRouter;
